module.exports = "<span id=\"createTrackingEventManagerRoot\">\n    <button class=\"navbar-btn btn btn-default hidden-xs\" ng-disabled=\"!createTrackingEventManager.isSignedIn\" ng-click=\"createTrackingEventManager.launchCreateTrackingEventDialog()\">Create Event</button>\n    <a href class=\"hidden-lg hidden-md hidden-sm\" ng-disabled=\"!createTrackingEventManager.isSignedIn\" ng-click=\"createTrackingEventManager.launchCreateTrackingEventDialog()\">Create Event</a>\n</span>"


//////////////////
// WEBPACK FOOTER
// ./src/views/create-tracking-event-dialog/CreateTrackingEventDialogManager.tpl.html
// module id = Pt/6
// module chunks = 1